<template>
  <footer class="footer-two">
    <div class="sec-bg">
      <img src="@/assets/img/bg/sec-bg-wave.png" alt="Img" />
      <img src="@/assets/img/bg/anchor-img-02.png" alt="Img" />
    </div>
    <div class="container">
      <div class="footer-top">
        <div class="row">
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div class="footer-widget">
              <div class="widget-title">
                <h4>Company</h4>
                <ul class="footer-links">
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Our Company</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Yacht Rent</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Dreams rent USA</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Dreams rent
                      Worldwide</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Dreams rent
                      Category</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div class="footer-widget">
              <div class="widget-title">
                <h4>Vehicles Type</h4>
                <ul class="footer-links">
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Electric</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Scooters</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Sports</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Racing Bikes</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Off-road</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div class="footer-widget">
              <div class="widget-title">
                <h4>Quick links</h4>
                <ul class="footer-links">
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>My account</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Campaigns</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Dreams rent
                      Dealers</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Deals and
                      Incentive</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Financial Services</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div class="footer-widget">
              <div class="widget-title">
                <h4>Resources</h4>
                <ul class="footer-links">
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Support</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Security</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Help Centers</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Preferences</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Customers</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div class="footer-widget">
              <div class="widget-title">
                <h4>Getting Started</h4>
                <ul class="footer-links">
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Introduction</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Documentation</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Usage</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>API</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i>Elements</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div class="footer-widget">
              <div class="widget-title">
                <h4>24/7 Live Support</h4>
                <ul class="footer-address">
                  <li>Want to book a Yacht instantly Contact Us !!!</li>
                  <li>Contact : + 1 (888) 760 1940</li>
                  <li>Emergency : +1 68564 55664</li>
                  <li>Email : support@example.com</li>
                  <li class="social-link">
                    <ul>
                      <li>
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-facebook-f"></i
                        ></a>
                      </li>
                      <li>
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-instagram"></i
                        ></a>
                      </li>
                      <li>
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-behance"></i
                        ></a>
                      </li>
                      <li>
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-twitter"></i
                        ></a>
                      </li>
                      <li>
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-pinterest-p"></i
                        ></a>
                      </li>
                      <li>
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-linkedin"></i
                        ></a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="copy-right">
          <p>
            Copyright &copy; {{ new Date().getFullYear() }} <span> Dreams Rent</span> . All Rights
            Reserved.
          </p>
        </div>
        <div class="app-store-links d-flex align-items-center">
          <span class="me-2"
            ><a href="javascript:void(0);"
              ><img src="@/assets/img/icons/google-play.svg" alt="Img" /></a
          ></span>
          <span
            ><a href="javascript:void(0);"
              ><img src="@/assets/img/icons/app-store.svg" alt="Img" /></a
          ></span>
        </div>
      </div>
    </div>
  </footer>
</template>
